import React, { useMemo } from 'react';
import cx from 'classnames';
import '../../../common/DateFormat/index.js';
import '@anton.bobrov/react-hooks';
import '@anton.bobrov/react-components';
import '../../../common/GradientWrapper/index.js';
import { Icon } from '../../../common/Icon/index.js';
import '../../../common/LazyImage/index.js';
import '../../../common/NumberFormat/index.js';
import '../../../common/WithCustomScrollbar/index.js';
import { RewardIcon } from '../RewardIcon/index.js';
import { RewardStatus } from '../RewardStatus/index.js';
import { RewardIconWrapper } from '../RewardIconWrapper/index.js';
import styles from './index.module.scss.js';

const vipColors = {
  zero: "#E2A684",
  rookie: "#E2A684",
  bronze: "#E2A684",
  silver: "#B8B8B8",
  gold: "#F9D37E",
  platinum: "#D4D4D4",
  pearl: "#DAD7D2",
  onyx: "#B3AEB3",
  diamond: "#E79CF7",
  palladium: "#E3DED4",
  castle: "#7DFBFD"
};
const VipIcon = ({
  level,
  levelText,
  color,
  progress = 0,
  showStatus,
  reverse,
  v2,
  size = "md",
  background,
  gradientBackground,
  vipIconStringType,
  noText,
  isAvailable = true,
  texts = {
    status: {
      complete: "Completed",
      incomplete: "Incomplete",
      inactive: "Inactive",
      soon: "Coming soon"
    }
  },
  className,
  style,
  ...props
}) => {
  const levelStr = useMemo(() => level?.toLowerCase().split(" ")[0], [level]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, className, {
        [styles.v2]: v2,
        [styles.reverse]: reverse,
        [styles[size]]: !!size,
        [styles["no-available"]]: !isAvailable
      }),
      style,
      "data-vip-icon-box": true,
      ...props
    },
    isAvailable && /* @__PURE__ */ React.createElement(React.Fragment, null, background && !gradientBackground && /* @__PURE__ */ React.createElement("div", { className: cx(styles["icon-bg"], "vip-icon-wrapper") }, /* @__PURE__ */ React.createElement("div", { className: styles.icon, "data-vip-icon": true }, /* @__PURE__ */ React.createElement(
      RewardIcon,
      {
        icon: levelStr?.toLowerCase(),
        stringType: vipIconStringType
      }
    ))), gradientBackground && /* @__PURE__ */ React.createElement(
      RewardIconWrapper,
      {
        className: "vip-icon-wrapper",
        icon: levelStr?.toLowerCase()
      },
      /* @__PURE__ */ React.createElement(
        RewardIcon,
        {
          icon: levelStr?.toLowerCase(),
          stringType: vipIconStringType
        }
      )
    ), !background && !gradientBackground && /* @__PURE__ */ React.createElement("div", { className: cx(styles.icon, "vip-icon-wrapper"), "data-vip-icon": true }, /* @__PURE__ */ React.createElement(
      RewardIcon,
      {
        icon: levelStr?.toLowerCase(),
        stringType: vipIconStringType
      }
    ))),
    !isAvailable && /* @__PURE__ */ React.createElement("div", { className: cx(styles["icon-bg"], "vip-icon-wrapper") }, /* @__PURE__ */ React.createElement("div", { className: styles.icon, "data-vip-icon": true }, /* @__PURE__ */ React.createElement(Icon, { iconName: "Lock" }))),
    !noText && /* @__PURE__ */ React.createElement("div", { className: styles.text, "data-vip-text": true }, /* @__PURE__ */ React.createElement(
      "span",
      {
        style: {
          "--color": color || vipColors[levelStr]
        }
      },
      levelText || level
    ), showStatus && /* @__PURE__ */ React.createElement(
      RewardStatus,
      {
        "data-vip-status": true,
        text: texts.status,
        status: !isAvailable ? "soon" : progress >= 100 ? "complete" : "incomplete"
      }
    ))
  );
};
VipIcon.displayName = "VipIcon";

export { VipIcon, vipColors };
//# sourceMappingURL=index.js.map
